<template>
  <div class="single-column-wrapper" style="max-width: 880px; margin: auto">
    <div class="column-body">
      <slot name="column-body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleColumnLayout'
}
</script>

<style>
.column-body {
  margin-top: 30px;
}
</style>
